<template>
    <div class="button_add mb-4">
        <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="add_item">
            <span class="fal  fa-eject mr-1"></span>
            {{__t('ADD')}}
        </button>

        <div class="time_info">
            <ul class="list-style-none">
                <li class="mt-2 list-style-none" v-for="(item,idx) in this.items">
                    <div class="row row-no-padding">
                        <div class="col-10">
                            <div class="input-group flex-nowrap">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="fal  fa-typewriter fs-xl" ></i>
                                    </span>
                                </div>
                                <input :id="cur_type + idx" type="text" class="form-control" v-model="item.param_val">
                            </div>
                        </div>

                        <div class="col-2">
                            <button type="button" class="btn btn-outline-danger w-100" v-on:click="remove(idx)">
                                {{__t('REMOVE')}}
                            </button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>


<script>
import Info_field from "../../../../sys/info_field.vue";

export default {
    name: "product_extra_input",
    components: {Info_field},
    props : {
        cur_idx : {
            type : Number,
            required : true
        },
        items : {
            type : Array,
        },
        cur_type : {
            type : String
        }
    },

    data() {
        return {

        }
    },

    methods : {

        on_set() {
            this.$emit('change',this.items,this.cur_type);
        },

        created () {


        },

        add_item() {
            this.items.push({
                "param_val" : "",
            });
            this.on_set();
        },

        remove(idx) {
            this.items.splice(idx,1);
            this.on_set();
        }

    }
}
</script>



<style scoped>
.list-style-none {
    padding-left: 0;
    margin-left: 0;
    list-style: none;
}
</style>
